<template>
  <section class="border bg-white rounded-md p-3">
    <div class="text-xl font-bold">{{ $t('pages.game.statistics.label') }}</div>
    <h2 class="mt-1 text-sm text-slate-500">
      {{ $t('pages.game.statistics.heading', { home: game.home?.name, away: game.away?.name, date: useDate(game?.startDate).format('HH:mm YYYY-MM-DD') }) }}
    </h2>
    <div class="mt-3 overflow-hidden rounded border border-slate-200">
      <div
        v-for="(row, index) in tableRows"
        :key="row.label"
        :class="[
          'grid grid-cols-[1fr_2fr_1fr] items-center border-t border-slate-200 first:border-t-0 py-2',
          index % 2 === 0 ? 'bg-slate-100' : ''
        ]"
      >
        <span class="text-center font-bold">
          {{ row.homeValue }}
        </span>
        <span class="text-center max-sm:text-sm">
          {{ row.label }}
        </span>
        <span class="text-center font-bold">
          {{ row.awayValue }}
        </span>
      </div>
    </div>
  </section>
</template>

<script setup>
const props = defineProps({
  game: {
    type: Object,
    default: () => ({})
  }
})

const statistics = computed(() => props.game.statistics)

const tableRows = computed(() => {
  const possession = statistics.value?.possession
  const shotsOnTarget = statistics.value?.shotsOnTarget
  const cornerKicks = statistics.value?.cornerKicks
  const fouls = statistics.value?.fouls
  const yellowCards = statistics.value?.yellowCards

  return [
    {
      label: 'Possession',
      homeValue: possession ? `${possession?.home}%` : '',
      awayValue: possession ? `${possession?.away}%` : '',
    },
    {
      label: 'Shots on Goal',
      homeValue: shotsOnTarget?.home,
      awayValue: shotsOnTarget?.away,
    },
    {
      label: 'Corner Kicks',
      homeValue: cornerKicks?.home,
      awayValue: cornerKicks?.away,
    },
    {
      label: 'Fouls',
      homeValue: fouls?.home,
      awayValue: fouls?.away,
    },
    {
      label: 'Yellow Cards',
      homeValue: yellowCards?.home,
      awayValue: yellowCards?.away,
    }
  ]
})
</script>
